import { useEffect, useState } from 'react';
import axios from 'axios';
import { BarChart3 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/sports-betting/pick-rules/analytics`;
const pct = (v) => `${Math.round((v || 0) * 100)}%`;

// How each football stat type does on your tickets, and who put up 0 (not playing / no role).
export default function FootballLegStats() {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/nfl`).then((r) => setD(r.data)).catch(() => setD({ stats: [], zero_players: [] })); }, []);
  if (!d) return null;
  return (
    <div className="space-y-2 rounded-xl border border-zinc-800 bg-zinc-900/40 p-3" data-testid="football-leg-stats">
      <p className="flex items-center gap-1.5 text-sm font-bold text-sky-300"><BarChart3 className="h-4 w-4" />Your football legs by stat</p>
      {d.stats.length === 0 ? <p className="text-xs text-zinc-500">No settled football player legs yet.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-xs" data-testid="football-leg-stats-table">
            <thead><tr className="text-left text-zinc-500"><th className="py-1">Stat</th><th>Legs</th><th>Hit</th><th>Short by (avg)</th><th>Got 0</th></tr></thead>
            <tbody>
              {d.stats.map((s) => (
                <tr key={s.stat} className="border-t border-zinc-800" data-testid={`football-stat-${s.stat}`}>
                  <td className="py-1 capitalize text-white">{s.stat.replace(/_/g, ' ').replace(/tds?$/i, 'TDs')}</td>
                  <td>{s.legs}</td>
                  <td className={s.hit_rate >= 0.7 ? 'text-emerald-300' : s.hit_rate >= 0.5 ? 'text-amber-300' : 'text-red-300'}>{pct(s.hit_rate)}</td>
                  <td>{s.avg_short_by != null ? s.avg_short_by : '—'}</td>
                  <td className={s.zero ? 'text-red-300 font-bold' : ''}>{s.zero}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {d.zero_players.length > 0 && (
        <p className="text-[11px] text-zinc-400" data-testid="football-zero-players">
          Put up 0 on your tickets (likely didn't play / no role): {d.zero_players.map((z) => `${z.name} (${z.stat.replace(/_/g, ' ')}${z.times > 1 ? ` ×${z.times}` : ''})`).join(', ')}.
          Picks now check ESPN's depth chart and last game, and skip players who aren't starting.
        </p>
      )}
    </div>
  );
}
